import { EMPLOYEE_STATUS_DATA, EMPLOYEE_STATUS_GET_DATA, EMPLOYEE_STATUS_ADD_DATA, EMPLOYEE_STATUS_UPDATE_DATA, EMPLOYEE_STATUS_DELETE_DATA } from './Constants'
const initialState = {
    loading: false,
    error: null,
    employeeStatuses: [],
    employeeStatus:{}
}
const Reducer = (state = initialState, action) => {
    switch (action.type) {
        //load all
        case EMPLOYEE_STATUS_DATA.EMPLOYEE_STATUS_DATA_LOAD:
            return {
                ...state,
                loading: true,
                employeeStatuses:[],
                error:null
            }
        case EMPLOYEE_STATUS_DATA.EMPLOYEE_STATUS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                error:null,
                employeeStatuses:action.employeeStatuses
            }
        case EMPLOYEE_STATUS_DATA.EMPLOYEE_STATUS_DATA_FAIL:
            return {
                ...state,
                loading: false,
                error:action.error,
            }
        //load single
        case EMPLOYEE_STATUS_GET_DATA.EMPLOYEE_STATUS_GET_DATA_LOAD:
            return {
                ...state,
                loading:true,
                employeeStatus:{},
                error:null
            }                

        case EMPLOYEE_STATUS_GET_DATA.EMPLOYEE_STATUS_GET_DATA_SUCCESS:
            return {
                ...state,
                loading:false,
                employeeStatus:action.employeeStatus
            }                

        case EMPLOYEE_STATUS_GET_DATA.EMPLOYEE_STATUS_GET_DATA_FAIL:
            return {
                ...state,
                loading:false,
                error:action.error
            }
        case EMPLOYEE_STATUS_ADD_DATA.EMPLOYEE_STATUS_ADD_DATA_LOAD:
            return {
                ...state,
                loading:true,
                error:null
            }
        case EMPLOYEE_STATUS_ADD_DATA.EMPLOYEE_STATUS_ADD_DATA_SUCCESS:
            return {
                ...state,
                loading:false
            }
        case EMPLOYEE_STATUS_ADD_DATA.EMPLOYEE_STATUS_ADD_DATA_FAIL:
            return {
                ...state,
                loading:false,
                error:action.error
            }
        case EMPLOYEE_STATUS_UPDATE_DATA.EMPLOYEE_STATUS_UPDATE_DATA_LOAD:
            return {
                ...state,
                loading:true,
                error:null
            }
        case EMPLOYEE_STATUS_UPDATE_DATA.EMPLOYEE_STATUS_UPDATE_DATA_SUCCESS:
            return {
                ...state,
                loading:false,
            }
        case EMPLOYEE_STATUS_UPDATE_DATA.EMPLOYEE_STATUS_UPDATE_DATA_FAIL:
            return {
                ...state,
                loading:false,
                error:action.error
            }
        case EMPLOYEE_STATUS_DELETE_DATA.EMPLOYEE_STATUS_DELETE_DATA_LOAD:
            return {
                ...state,
                loading:true,
                error:null
            }
        case EMPLOYEE_STATUS_DELETE_DATA.EMPLOYEE_STATUS_DELETE_DATA_SUCCESS:
            return {
                ...state,
                loading:false,
            }
        case EMPLOYEE_STATUS_DELETE_DATA.EMPLOYEE_STATUS_DELETE_DATA_FAIL:
            return {
                ...state,
                loading:false,
                error:action.error
            }
        default:
            return {
                ...state
            }
    }
}
export default Reducer